import messengerIcon from '@/components/results-category/images/messenger-icon.svg';
import smsIcon from '@/components/results-category/images/sms-icon.svg';
import emailIcon from '@/components/results-category/images/email-icon.svg';
import mildHearingSideImage from '@/components/results-category/images/mild-hearing-side-image.webp';
import mildHearingIcon from '@/components/results-category/images/mild-hearing-icon.webp';
import normalHearingSideImage from '@/components/results-category/images/normal-hearing-side-image.webp';
import normalHearingIcon from '@/components/results-category/images/normal-hearing-icon.webp';
import severeHearingSideImage from '@/components/results-category/images/severe-hearing-side-image.webp';
import severeHearingIcon from '@/components/results-category/images/severe-hearing-icon.webp';
import headphonesIcon from '@/components/results-category/images/headphones-icon.webp';
import otcBenefitsSideImage from '@/components/results-category/images/otc-benefits-side-image.webp';
export var resultCategorySvgs = {
    emailIcon: emailIcon,
    smsIcon: smsIcon,
    messengerIcon: messengerIcon,
};
export var resultCategoryImages = {
    mildHearingSideImage: mildHearingSideImage,
    mildHearingIcon: mildHearingIcon,
    normalHearingSideImage: normalHearingSideImage,
    normalHearingIcon: normalHearingIcon,
    severeHearingSideImage: severeHearingSideImage,
    severeHearingIcon: severeHearingIcon,
    headphonesIcon: headphonesIcon,
    otcBenefitsSideImage: otcBenefitsSideImage,
};
